import { create } from "zustand";

import { PRODUCT_STATUS } from "../models/Product";

export const enum MODE {
  EDIT = "Edit",
  VIEW = "View",
}

export const enum FORM_STATE {
  NEW = "NEW",
  SAVED = "SAVED",
}

type State = {
  mode: MODE;
  formState: FORM_STATE;
  imageFiles: Record<string, File>;
  imageCount: number;
  status?: PRODUCT_STATUS;
};

type Actions = {
  setMode: (mode: MODE) => void;
  setFormState: (state: FORM_STATE) => void;
  addImageFile: (fieldName: string, file: File) => void;
  reset: (state?: Partial<State>) => void;
  resetImages: () => void;
  setStatus: (status?: PRODUCT_STATUS) => void;
};

const initialState: State = {
  mode: MODE.EDIT,
  formState: FORM_STATE.NEW,
  imageFiles: {},
  imageCount: 0,
  status: PRODUCT_STATUS.DRAFT,
};

export const useFormStore = create<State & Actions>(set => ({
  ...initialState,

  setMode: (mode: MODE) => set({ mode }),
  setFormState: (formState: FORM_STATE) => set({ formState }),

  addImageFile: (fieldName, file) => {
    set(state => ({
      imageFiles: { ...state.imageFiles, [fieldName]: file },
      imageCount: state.imageFiles[fieldName]
        ? state.imageCount
        : state.imageCount + 1,
    }));
  },

  reset: (state?: Partial<State>) => {
    set({ ...initialState, ...state });
  },

  resetImages: () => {
    set({ imageCount: 0, imageFiles: {} });
  },

  setStatus: status => {
    set({ status });
  },
}));
